import React from "react";


const Mensaje = () => {

    return (
        <ul className="dropdown-menu">
            <li>
                <p>Debe seleccionar usuarios con el mismo estado</p>
            </li>
        </ul>

    );


}

const BotonEliminar = (props) => {
    let numbers;
    let Eliminados;

    if (props.usuariosFiltrados != undefined) {
        numbers = props.usuariosFiltrados.find(x => x.Seleccionado == true) != undefined ? props.usuariosFiltrados.filter(x => x.Seleccionado == true).length : 0;
        Eliminados = props.usuariosFiltrados.filter(x => x.Seleccionado == true && x.Activo == false && x.Bloqueado == false).length;
    }

    return (
        <div className="dropdown">
            <button className="btn btn-icon btn-trash"
                disabled={!(numbers > 0)}
                title="Eliminar los seleccionados" data-toggle="dropdown"
                onClick={(Eliminados >= 1) ? null: () => props.setUserState(null, false, false)}>
                <span className="ti-trash"></span>
            </button>
            {(Eliminados >= 1) ? null /*<Mensaje />*/ : null}
        </div>
        
    );
}

export default BotonEliminar;